import * as mt from './mutation-types';
import { MonitoringState, CropsYieldEvolutionPayload} from './types'

export default {
  [mt.CLEANUP](state: MonitoringState) {
    state.cropsYieldEvolutionContext = new Map();
    state.cropYieldEvolutionStatus = new Map();
  },

  [mt.FETCHING_CROP_YIELD_EVOLUTION](state: MonitoringState, { uuid }: { uuid: string }) {
    state.cropYieldEvolutionStatus.set(uuid, 'fetching');
    state.cropYieldEvolutionStatus = new Map(state.cropYieldEvolutionStatus);
  },
  [mt.FETCH_CROP_YIELD_EVOLUTION](state: MonitoringState, { uuid, cropYieldEvolution }: CropsYieldEvolutionPayload) {
    state.cropsYieldEvolutionContext.set(uuid, cropYieldEvolution);
    state.cropsYieldEvolutionContext = new Map(state.cropsYieldEvolutionContext);
    state.cropYieldEvolutionStatus.set(uuid, 'fetch');
    state.cropYieldEvolutionStatus = new Map(state.cropYieldEvolutionStatus);
  },
  [mt.FETCH_CROP_FAILURE](state: MonitoringState, { uuid }: { uuid: string }) {
    state.cropYieldEvolutionStatus.set(uuid, 'error');
    state.cropYieldEvolutionStatus = new Map(state.cropYieldEvolutionStatus);
  },
};
